import { useState, Fragment } from 'react';

function WebsiteScraperForm({ onSubmit, isLoading }) {
    const [url, setUrl] = useState('');
    const [error, setError] = useState('');
    const [urlValid, setUrlValid] = useState(false);
    try {

        const handleSubmit = async (e) => {
            e.preventDefault();
            setError('');

            if (!url.trim()) {
                setError('請輸入網站網址');
                return;
            }

            if (!isValidWebsiteUrl(url)) {
                setError('請輸入有效的網站網址');
                return;
            }

            if (isVideoWebsite(url)) {
                setError('不支援視頻網站，請輸入文字內容網站');
                return;
            }

            onSubmit(url);
        };

        const handleUrlChange = (e) => {
            const newUrl = e.target.value;
            setUrl(newUrl);
            setError('');
            
            // Validate URL as user types
            if (newUrl.trim()) {
                const isValid = isValidWebsiteUrl(newUrl) && !isVideoWebsite(newUrl);
                setUrlValid(isValid);
            } else {
                setUrlValid(false);
            }
        };

        function isValidWebsiteUrl(url) {
            try {
                const urlObj = new URL(url);
                return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';
            } catch (e) {
                return false;
            }
        }

        function isVideoWebsite(url) {
            const videoSites = [
                'youtube.com', 'youtu.be', 'vimeo.com', 'dailymotion.com', 
                'twitch.tv', 'tiktok.com', 'instagram.com/reel', 'instagram.com/tv',
                'facebook.com/watch', 'bilibili.com', 'nicovideo.jp',
                'netflix.com', 'hulu.com', 'disney.com', 'disneyplus.com',
                'crunchyroll.com', 'funimation.com', 'viki.com'
            ];
            
            try {
                const hostname = new URL(url).hostname;
                return videoSites.some(site => hostname.includes(site));
            } catch (e) {
                return false;
            }
        }

        return (
            <form onSubmit={handleSubmit} className="space-y-6" data-name="website-scraper-form">
                <div>
                    <label htmlFor="website-url" className="block text-sm font-medium text-gray-700 mb-2">
                        網站網址
                    </label>
                    <div className="flex gap-4">
                        <div className="relative flex-1">
                            <input
                                type="url"
                                id="website-url"
                                value={url}
                                onChange={handleUrlChange}
                                placeholder="https://example.com"
                                className={`w-full px-4 py-3 rounded-lg border ${
                                    error ? 'border-red-300 focus:ring-red-200 focus:border-red-400' : 
                                    urlValid ? 'border-green-300 focus:ring-green-200 focus:border-green-400' : 
                                    'border-gray-300 focus:ring-indigo-200 focus:border-indigo-400'
                                } transition-all pl-10`}
                                disabled={isLoading}
                                data-name="url-input"
                            />
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <i className={`fas fa-globe ${
                                    error ? 'text-red-400' : 
                                    urlValid ? 'text-green-500' : 
                                    'text-gray-400'
                                }`}></i>
                            </div>
                            {urlValid && url.trim() && (
                                <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                    <i className="fas fa-check text-green-500"></i>
                                </div>
                            )}
                        </div>
                        <button
                            type="submit"
                            className="px-6 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 focus:ring-4 focus:ring-indigo-200 transition-all flex items-center justify-center min-w-[120px]"
                            disabled={isLoading || !urlValid}
                            data-name="submit-button"
                        >
                            {isLoading ? (
                                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                            ) : (
                                <Fragment>
                                    <i className="fas fa-sync mr-2"></i>
                                    擷取內容
                                </Fragment>
                            )}
                        </button>
                    </div>
                    {error && (
                        <p className="mt-2 text-sm text-red-600" data-name="url-error">
                            <i className="fas fa-exclamation-circle mr-1"></i>
                            {error}
                        </p>
                    )}
                    {urlValid && url.trim() && !error && (
                        <p className="mt-2 text-sm text-green-600" data-name="url-valid">
                            <i className="fas fa-check-circle mr-1"></i>
                            網址有效，可以進行擷取
                        </p>
                    )}
                </div>

                {error && (
                    <div 
                        className="bg-red-50 border-l-4 border-red-400 p-4 rounded"
                        role="alert"
                        data-name="error-message"
                    >
                        <div className="flex">
                            <i className="fas fa-exclamation-circle text-red-400 mr-3"></i>
                            <p className="text-red-700">{error}</p>
                        </div>
                    </div>
                )}

                <div className="mt-4 bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded">
                    <div className="flex">
                        <i className="fas fa-info-circle text-yellow-500 mr-3"></i>
                        <div className="text-yellow-700">
                            <p className="font-medium mb-1">請注意：</p>
                            <ul className="list-disc pl-5 space-y-1">
                                <li>只支援文字內容網站，不支援視頻網站</li>
                                <li>內容擷取可能需要一些時間，請耐心等待</li>
                                <li>部分網站可能因保護措施而無法擷取內容</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </form>
        );
    } catch (error) {
        console.error('WebsiteScraperForm component error:', error);
        reportError(error);
        return null;
    }
}

export default WebsiteScraperForm;